/*****************************************************************
 * DO NOT MANUALLY EDIT THIS FILE!                               *
 *                                                               *
 * This file is auto-generated by 'yarn prepare'                 *
 *****************************************************************/

import { LazyModal } from '@freelancer/ui/modal';

export const uiModals: { [k: string]: LazyModal } = {
  CameraModal: {
    loadComponent: () =>
      import('@freelancer/ui/camera-modal/camera-modal.component').then(
        m => m.CameraModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/camera-modal/camera-modal.module').then(
        m => m.CameraModalModule,
      ),
  },
  UpdateNativeModal: {
    loadComponent: () =>
      import(
        '@freelancer/ui/update-native-alert/modal/update-native-modal.component'
      ).then(m => m.UpdateNativeModalComponent),
    loadModule: () =>
      import(
        '@freelancer/ui/update-native-alert/modal/update-native-modal.module'
      ).then(m => m.UpdateNativeModalModule),
  },
  VideoModal: {
    loadComponent: () =>
      import('@freelancer/ui/video-modal/video-modal.component').then(
        m => m.VideoModalComponent,
      ),
    loadModule: () =>
      import('@freelancer/ui/video-modal/video-modal.module').then(
        m => m.VideoModalModule,
      ),
  },
};
